import keyMirror from 'keymirror';

export { AttachmentTypes, Services } from '~/constants';

export { NotificationTypes, NotificationScopes } from './values/Notification';

export const DataImportEnvironments = keyMirror({
  BOOKMARKLET_PHP: null, // The document at /add, served through bookmarklet.php
  WEB_DASHBOARD: null, // Anywhere in the web dashboard
  CALENDAR: null, // In the calendar page
  CAMPAIGNS: null, // In the campaigns page
  EXTENSION: null, // In the extension compose page
});

export const LinkAttachmentTextFieldTypes = keyMirror({
  TITLE: null,
  DESCRIPTION: null,
});

export const ErrorTypes = keyMirror({
  INLINE: null,
  FLOATING: null,
});

export const FloatingErrorCodes = [
  401, 403, 404, 405, 429, 1000, 1001, 1002, 1003, 1005, 1006, 1007, 1042, 1050,
  1051,
];

export const UpgradeErrorCodes = {
  queueLimit: 1023, // Reached profile queue limit
};

export const ComposerInitiators = {
  ImageBufferButtons: ['hover_button_image', 'menu-image'],
};

export const QueueingTypes = keyMirror({
  QUEUE: null,
  NEXT: null,
  NOW: null,
  CUSTOM: null,
  SAVE: null,
  SAVE_AND_APPROVE: null,
  ADD_DRAFT: null,
  NEXT_DRAFT: null,
  CUSTOM_DRAFT: null,
});

export const SaveButtonTypes = keyMirror({
  ADD_TO_QUEUE: null,
  SHARE_NEXT: null,
  SHARE_NOW: null,
  SCHEDULE_POST: null,
  SAVE: null,
  SAVE_AND_APPROVE: null,
  ADD_TO_DRAFTS: null,
  SCHEDULE_DRAFT: null,
});

export const PaywallButtonTypes = keyMirror({
  REQUEST_APPROVAL: null,
});

export const InlineSaveButtonTypes = [
  SaveButtonTypes.SAVE,
  SaveButtonTypes.SAVE_AND_APPROVE,
];

export const ButtonsQueuingTypesMap = new Map([
  [SaveButtonTypes.ADD_TO_QUEUE, QueueingTypes.QUEUE],
  [SaveButtonTypes.SHARE_NEXT, QueueingTypes.NEXT],
  [SaveButtonTypes.SHARE_NOW, QueueingTypes.NOW],
  [SaveButtonTypes.SCHEDULE_POST, QueueingTypes.CUSTOM],
  [SaveButtonTypes.SAVE, QueueingTypes.SAVE],
  [SaveButtonTypes.SAVE_AND_APPROVE, QueueingTypes.SAVE_AND_APPROVE],
  [SaveButtonTypes.ADD_TO_DRAFTS, QueueingTypes.ADD_DRAFT],
  [SaveButtonTypes.SCHEDULE_DRAFT, QueueingTypes.CUSTOM_DRAFT],
]);

export const AsyncOperationStates = keyMirror({
  PENDING: null,
  DONE: null,
});

export const MediaUploadConfig = {
  endpoint: '/upload/media',
};

export const bufferOriginRegex = /https?:\/\/(?:[^.]+\.)?buffer(?:app)?\.com/;
export const bufferOrigins = new Map([
  ['local', 'https://local.buffer.com'],
  [
    'production',
    bufferOriginRegex.test(window.location.origin)
      ? window.location.origin
      : 'https://buffer.com',
  ],
]);

export const InstagramAspectRatioLimits = {
  min: 0.8,
  max: 1.91,
};

export const InstagramThumbnailMaxSize = 500;
